import * as io from "io-ts";
import { BlockImport, BlockModel } from ".";
import { FaultResource } from "../resource/fault";
import { QuantityResource } from "../resource/quantity";
import { withMessage } from "io-ts-types";
import t from "../../../../../i18n";
import { BlockData } from "./data";

export const BlockTableKind = withMessage(io.strict({ kind: io.literal("TABLE") }), () =>
  t("schema.block.kind"),
);

export const BlockTableResource = io.type({
  quantity: io.union([QuantityResource, io.undefined]),
  fault: io.union([FaultResource, io.undefined]),
});
export type BlockTableResourceT = io.TypeOf<typeof BlockTableResource>;

export const BlockTableData = io.type({
  data: BlockData,
});

export const BlockTableModel = io.intersection([BlockModel, BlockTableKind, BlockTableData]);

export const BlockTableImport = io.intersection([BlockImport, BlockTableKind, BlockTableData]);

export type BlockTableModelT = io.TypeOf<typeof BlockTableModel>;
export type BlockTableImportT = io.TypeOf<typeof BlockTableImport>;
